import React, { useEffect } from 'react';
import { DrawerToggleState } from '../../models/actionStates';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import { assetPathFnState, mobileMenuOpenState } from '../../recoil/atoms';
import { cartDrawerState, cartState } from '../../recoil/selectors';
import styles from './CartIcon.module.scss';
import { ImageButton } from './buttons/ImageButton';
import classNames from 'classnames';
import { lockParentWithScrollingChild, unlockParentWithScrollingChild } from '../../util';
import { ShopifyLineItem } from '../../models/ShopifyLineItem.model';

interface Props {
  isMobile?: boolean;
}

const CartIcon: React.FC<Props> = ({ isMobile }) => {
  const cart = useRecoilValue(cartState);
  const [cartDrawer, setCartDrawer] = useRecoilState(cartDrawerState);
  const assetPathFn = useRecoilValue(assetPathFnState);
  const setMobileNavMenu = useSetRecoilState(mobileMenuOpenState);

  useEffect(() => {
    if (cartDrawer?.toggleState === DrawerToggleState.Open) {
      lockParentWithScrollingChild();
    } else {
      unlockParentWithScrollingChild();
    }
    return () => {
      unlockParentWithScrollingChild();
    };
  }, [cartDrawer?.toggleState]);

  const openCartDrawer = () => {
    setCartDrawer({
      toggleState: DrawerToggleState.Open,
    });
    setMobileNavMenu(false);
  };

  const consolidatedItems = (cart.lineItems ?? []).reduce<ShopifyLineItem[]>((acc, curr) => {
    if (
      acc.some(
        (li) =>
          curr.properties?._bundleHandle &&
          li.properties?._bundleHandle === curr.properties._bundleHandle &&
          li.properties?._bundleKey === curr.properties._bundleKey,
      )
    )
      return acc;
    return [...acc, curr];
  }, []);
  const itemCount = consolidatedItems.length;

  return (
    <ImageButton
      dataTrackLabel="Cart"
      dataTrackLocation={isMobile ? 'mobile-menu' : 'header'}
      onClick={openCartDrawer}
      image={
        <div className={classNames(styles.hlBagLink, { [styles.hlMobileBagLink]: isMobile })}>
          <img className={styles.svgIcon} src={assetPathFn('bag-icon.svg')} height="36" width="31" alt="bag" />
          {itemCount > 0 && <span className={styles.cartCount}>{itemCount}</span>}
        </div>
      }
    />
  );
};

export default CartIcon;
